import {
  faCamera,
  faCircleUser,
  faAddressCard,
  faCrown,
  faRightFromBracket,
} from '@fortawesome/pro-regular-svg-icons';
import { useTranslations } from 'next-intl';
import { appRoutes } from 'config/routing';
import { useRouter } from 'core/i18n/navigation';
import useAuthenticatedUser from 'networking/mindfeed/hooks/useAuthenticatedUser';
import { requestToLogout } from 'xstate/actors/AuthActor';
import { openProfilePhotoModal } from 'xstate/actors/ModalActor';
import type { ActionMenuEntry } from 'elements/ActionMenu';

// The account menu shared by the header user button and the rail avatar menu.
export const useAccountMenuItems = (): ActionMenuEntry[] => {
  const t = useTranslations('accountMenu');
  const router = useRouter();
  const { authenticatedUser } = useAuthenticatedUser();

  // Nudge people without a photo to add one. Once they have one, the menu
  // doesn't need it.
  const addPhoto: ActionMenuEntry[] = authenticatedUser?.profileImage
    ? []
    : [
        {
          icon: faCamera,
          label: t('addPhoto'),
          onClick: openProfilePhotoModal,
        },
        'separator',
      ];

  return [
    ...addPhoto,
    {
      icon: faCircleUser,
      label: t('profile'),
      onClick: () => router.push(appRoutes.SETTINGS.PROFILE),
    },
    {
      icon: faAddressCard,
      label: t('account'),
      onClick: () => router.push(appRoutes.SETTINGS.ACCOUNT),
    },
    {
      icon: faCrown,
      label: t('pro'),
      onClick: () => router.push(appRoutes.SETTINGS.SUBSCRIPTION),
    },
    'separator',
    {
      icon: faRightFromBracket,
      label: t('signOut'),
      danger: true,
      onClick: () => requestToLogout(),
    },
  ];
};
